import { Add } from 'iconsax-react';
import { MessageQuote } from '@/components/conversations/conversation-list/message-list-item/message-content/message-quote';
import useConversationForm from '@/hooks/conversations/use-conversation-form';

export default function ConversationFormQuoteArea() {
  const { form, handleUpdateDraft } = useConversationForm();
  const quote = form.watch('Quote');

  return quote ? (
    <div
      data-quote='quote'
      className='group/form flex items-center gap-2 border-t border-t-base-200 desktop:bg-base-200 desktop:border-t-0 desktop:rounded desktop:ms-20 desktop:me-5 px-5 desktop:pb-2 pt-2'>
      <MessageQuote
        quote={quote}
        className='flex-1 bg-transparent border-0 pointer-events-none p-0'
      />

      <button
        type='button'
        className='btn btn-ghost btn-square btn-sm'
        onClick={() => {
          form.setValue('Quote', undefined);
          handleUpdateDraft();
        }}>
        <Add className='size-6 rotate-45' />
      </button>
    </div>
  ) : null;
}
